export default function IconGift({ color = "white", size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size + 1}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M20 13.3333V35M20 13.3333C20 13.3333 20 10.8454 20 10C20 8.15905 21.4924 6.66667 23.3333 6.66667C25.1743 6.66667 26.6667 8.15905 26.6667 10C26.6667 11.8409 25.1743 13.3333 23.3333 13.3333C22.3378 13.3333 20 13.3333 20 13.3333ZM20 13.3333C20 13.3333 20 10.1049 20 9.16667C20 6.86548 18.1345 5 15.8333 5C13.5321 5 11.6667 6.86548 11.6667 9.16667C11.6667 11.4679 13.5321 13.3333 15.8333 13.3333C17.1963 13.3333 20 13.3333 20 13.3333ZM8.33333 20H31.6667M8.33333 20C6.49238 20 5 18.5076 5 16.6667C5 14.8257 6.49238 13.3333 8.33333 13.3333H31.6667C33.5076 13.3333 35 14.8257 35 16.6667C35 18.5076 33.5076 20 31.6667 20M8.33333 20L8.33333 31.6667C8.33333 33.5076 9.82572 35 11.6667 35H28.3333C30.1743 35 31.6667 33.5076 31.6667 31.6667V20"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
}
